import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { isValidName } from '../common/utilities/Validations';
import { CREATE_TABLE_IMPORT, GENERIC_DATA_CREATE_TABLES_WITH_ATTRIBUTES, getApiPath } from "../../api/ApiConst"
import apiCaller from "../../api/ApiCaller";
import { toast } from 'react-toastify';

const TableImport = (props) => {
    const [jsonData, setJsonData] = useState("");

    const toggle = () => {
        props.close();
        setJsonData("");
    }

    const handleImportTable = async () => {
        if (!jsonData || jsonData.trim() === "") {
            toast.error("Please enter JSON data");
            return false;
        }

        try {
            const parsedData = JSON.parse(jsonData);
            
            if (!Array.isArray(parsedData)) {
                toast.error("Please enter a valid JSON. JSON must be an array of objects.");
                return false;
            }

            if (parsedData.length === 0) {
                toast.error("Please enter a valid JSON. Array cannot be empty.");
                return false;
            }

            const cleanedData = [];
            for (let i = 0; i < parsedData.length; i++) {
                const obj = parsedData[i];
                const objectIndex = i + 1;

                if (!obj || typeof obj !== 'object') {
                    toast.error(`Object at index ${objectIndex} is not a valid object`);
                    return false;
                }

                const cleanedObj = {
                    name: obj.name ? obj.name.trim() : "",
                    description: obj.description ? obj.description.trim() : "",
                    pathValue: obj.pathValue ? obj.pathValue.trim() : "",
                    addDefaultAttribute: obj.addDefaultAttribute || false,
                    isMultiTenantTable: obj.isMultiTenantTable || false,
                    attributes: obj.attributes || []
                };

                if (!cleanedObj.name || cleanedObj.name === "") {
                    toast.error(`Object at index ${objectIndex}: Name field cannot be empty or just spaces`);
                    return false;
                }
                if (!cleanedObj.description || cleanedObj.description === "") {
                    toast.error(`Object at index ${objectIndex}: Description field cannot be empty or just spaces`);
                    return false;
                }
                if (!cleanedObj.pathValue || cleanedObj.pathValue === "") {
                    toast.error(`Table ${objectIndex}: Path field cannot be empty or just spaces`);
                    return false;
                }

                if (!isValidName(cleanedObj.name)) {
                    toast.error(`Table ${objectIndex}: Invalid name format`);
                    return false;
                }

                if (!isValidName(cleanedObj.pathValue)) {
                    toast.error(`Table ${objectIndex}: Invalid path format`);
                    return false;
                }

                if (typeof cleanedObj.addDefaultAttribute !== 'boolean') {
                    toast.error(`Table ${objectIndex}: addDefaultAttribute must be a boolean value`);
                    return false;
                }

                if (typeof cleanedObj.isMultiTenantTable !== 'boolean') {
                    toast.error(`Table ${objectIndex}: isMultiTenantTable must be a boolean value`);
                    return false;
                }

                if (cleanedObj.attributes && !Array.isArray(cleanedObj.attributes)) {
                    toast.error(`Table ${objectIndex}: attributes must be an array`);
                    return false;
                }

                cleanedData.push(cleanedObj);
            }

            apiCaller.callPostApi(getApiPath(GENERIC_DATA_CREATE_TABLES_WITH_ATTRIBUTES), cleanedData, {}, (response) => {
                const successMessage = `${cleanedData.length} Tables Imported Successfully`;
                toast.success(successMessage);
                toggle();
                props.successCallBack()
            }, (error) => {
                toast.error(error);
            })

        } catch (error) {
            toast.error("Please enter a valid JSON. JSON must be an array of objects.");
            return false;
        }
    }

    return (
        <>
            <Modal show={props.show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Import Tables</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <textarea
                            className="form-control"
                            rows="10"
                            placeholder='Paste JSON here'
                            value={jsonData}
                            onChange={(e) => setJsonData(e.target.value)}
                            style={{ width: '100%' }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button 
                        className='btn btn-primary' 
                        onClick={handleImportTable}
                    >
                        Import Tables
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default TableImport 